export * from './default-quote-summary-config.constant';
